import { baseApi } from "../baseApi";

const pricingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listAllPricing: builder.query({
      query: () => `pricings`,
      providesTags:['Pricing'],
      
    }),
  }),
});

export const { useListAllPricingQuery } = pricingApi;
